import { render, staticRenderFns } from "./AdminSellerRecords.vue?vue&type=template&id=f0204114&lang=pug&"
import script from "./AdminSellerRecords.vue?vue&type=script&lang=js&"
export * from "./AdminSellerRecords.vue?vue&type=script&lang=js&"
import style0 from "./AdminSellerRecords.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports